import { createStore } from 'zustand'

import { RegisterStore } from './interface'

export const registerStore = createStore<RegisterStore>((set, get) => ({
  openId: undefined,
  form: {},
  current: 0,
  setOpenId(openId: string) {
    set({ openId, current: openId ? 1 : 0 })
  },
  setForm(form) {
    set({ form })
  },
  gotoResult() {
    set({ current: 2 })
  }
}))
